export default "__VITE_ASSET__C9l4tgvk__"